/**
 * LinkComponent — opens all rendered links in a new tab with rel=noopener.
 * Matches the current behavior in ChatMessageContent / PostContent /
 * MarkdownContent / MarkdownPreview / SupportDocsPage.
 *
 * CEL-3431 (Oct 14 2026): links to the three out-of-credits options (Billing, the plans section, our Stripe top-up
 * links) also carry data-track attributes, classified by destination, so the app-wide click layer records which
 * option was clicked. The href is never touched; every other link renders exactly as before.
 */
import React from 'react';
import { childrenText, creditOptionTrackAttrs } from '../../../../utils/creditOptionTracking';

const LinkComponent = React.memo((props) => {
  const track = creditOptionTrackAttrs(props.href, childrenText(props.children)) || {};
  return <a target="_blank" rel="noopener noreferrer" {...props} {...track} />;
});

LinkComponent.displayName = 'CellCogMarkdown.Link';

export default LinkComponent;
